import { observer } from 'mobx-react';
import InputComponent from '../../../../component/InputComponent';
import { Button, Col, Form, message, Row, Spin, Upload } from 'antd';
import { useState } from 'react';
import useStore from '../../../../store';
import { RegionType } from '../../../../config/Global';
import { regionRequest, templeRequest } from '../../../../request/AuthRequest';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import CommonEditor from '../../../../component/CommonEditor';
import FAQForm from '../../Temples/components/FAQComponent';

const FormComponent = observer((props) => {
	const { handleChange, onFinish, id, form, setFileLists, fileLists, templeContent, setTempleContent, propertyContent, setPropertyContent } = props;
	const [loading, setLoading] = useState(false);
	const [regions, setRegions] = useState([]);
	const {
		REGION: { getRegionList, regionDetail },
		AUTH: { stateList },
	} = useStore();

	const validateFile = (file) => {
		const isCorrectFile = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/jfif'].includes(
			file.type
		);
		const isLt2M = file.size / 1024 / 1024 < 2;
		if (!isCorrectFile) {
			message.error(`${file.name} is not a valid IMAGE file`);
			return false;
		}
		if (!isLt2M) {
			message.error('Image file must be smaller than 2MB!');
		}
		return isCorrectFile && isLt2M;
	};

	const getRegions = async (value) => {
		if (value !== null) {
			setLoading(true);
			try {
				const regionTypeData =
					value === RegionType.City
						? RegionType.State
						: RegionType.Country;

				const regionList = await getRegionList(regionTypeData);

				setRegions(regionList);
			} catch (error) {
			} finally {
				setLoading(false);
			}
		}
	};

	const handleRegionTypeChange = (value) => {
		getRegions(value);
		form.resetFields(['EParentRegionId']);
	};

	const beforeUpload = (file) => {
		if (validateFile(file)) {
			setFileLists([file]);
			return false; // Prevent automatic upload
		}
		return false; // Prevent automatic upload
	};

	return (
		<Form
			id={id}
			layout="vertical"
			form={form}
			onFinish={onFinish}
			autoComplete="off"
		>
			<Row gutter={24} >
				<Col span={5}>
					<InputComponent
						required
						type="select"
						showSearch={true}
						name="regionType"
						label="Select Region Type"
						placeholder="Select Region Type"
						onChange={(value) => {
							handleRegionTypeChange(value);
							handleChange();
						}}
						disabled={form.getFieldsValue().regionType === 'State'}
						options={{
							rejected_keys: [1, 2, 3, 5],
							values: Object.keys(RegionType).map((key) => ({
								eRegionId: RegionType[key],
								regionName: key,
							})),
							value_key: 'eRegionId',
							text_key: 'regionName',
						}}
						style={{ width: '200px', textAlign: 'left' }}
						rules={regionRequest.regionType}
					/>
				</Col>
				<Col span={5}>
					<InputComponent
						required
						type="select"
						showSearch={true}
						name="EParentRegionId"
						label="Select Parent Region"
						placeholder="Select Parent Region"
						options={{
							values: regions.length
								? regions.map((region) => ({
									eRegionId: region?.eRegionId,
									regionName: region?.regionName,
								}))
								: [
									{
										eRegionId:
											regionDetail?.eParentRegionId,
										regionName:
											regionDetail?.parentRegionName,
									},
								],
							value_key: 'eRegionId',
							text_key: 'regionName',
						}}
						disabled={!regions.length}
						style={{ width: '200px', textAlign: 'left' }}
						onChange={handleChange}
						notFoundContent={
							loading ? <Spin size="small" /> : 'No Regions Found'
						}
						rules={regionRequest.EParentRegionId}
					/>
				</Col>
				<Col span={5}>
					<InputComponent
						required
						name="regionCode"
						label="Region Code"
						placeholder="Enter Region Code"
						onChange={handleChange}
						rules={regionRequest.regionCode}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						name="regionName"
						label="Region Name"
						placeholder="Enter Region Name"
						onChange={handleChange}
						rules={regionRequest.regionName}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						name="propertySEOTitle"
						label="Property SEO Title"
						placeholder="Enter Property SEO Title"
						onChange={handleChange}
						rules={regionRequest.propertySEOTitle}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						name="propertyMetaTitle"
						label="Property Meta Title"
						placeholder="Enter Property Meta Title"
						onChange={handleChange}
						rules={regionRequest.metaTitle}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						name="propertyMetaDescription"
						label="Property Meta Description"
						placeholder="Enter Property Description"
						onChange={handleChange}
						rules={regionRequest.metaDescription}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						name="propertyMetaKeywords"
						label="Property Meta Keyword"
						placeholder="Enter Property Meta Keyword"
						onChange={handleChange}
						rules={regionRequest.metaKeyword}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						name="templeSEOTitle"
						label="Temple SEO Title"
						placeholder="Enter Temple SEO Title"
						onChange={handleChange}
						rules={regionRequest.templeSEOTitle}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						name="templeMetaTitle"
						label="Temple Meta Title"
						placeholder="Enter Temple Meta Title"
						onChange={handleChange}
						rules={regionRequest.metaTitle}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						name="templeMetaDescription"
						label="Temple Meta Description"
						placeholder="Enter Temple Meta Description"
						onChange={handleChange}
						rules={regionRequest.metaDescription}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						name="templeMetaKeywords"
						label="Temple Meta Keyword"
						placeholder="Enter Temple Meta Keyword"
						onChange={handleChange}
						rules={regionRequest.metaKeyword}
					/>
				</Col>
				<Col span={6}>
					<Form.Item label={'Select Region Image'}>
						<Form.Item noStyle>
							<Upload
								onChange={handleChange}
								name="file"
								maxCount={1}
								multiple={false}
								accept=".jpeg,.jpg,.png,.webp,.jfif"
								listType="picture"
								beforeUpload={beforeUpload}
								// onRemove={() => handleRemove(name)}
								fileList={fileLists || []}
								showUploadList={{
									showRemoveIcon: false,
								}}
							>
								<Button
									icon={<FontAwesomeIcon icon={faPlus} />}
								>
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Form.Item>
				</Col>
				<Col span={24}>
					<label className="ant-form-item-required" title="Temple Content">Temple Content</label>
					<CommonEditor
						value={templeContent || {}}
						onChange={(data) => { setTempleContent(data); handleChange() }}
					/>
				</Col>
				<Col span={24} style={{ marginTop: 16, marginBottom: 16 }}>
					<label className="ant-form-item-required" title="Property Content">Property Content</label>
					<CommonEditor
						value={propertyContent || {}}
						onChange={(data) => { setPropertyContent(data); handleChange() }}
					/>
				</Col>
				<Col span={12}>
					<Form.Item label="Temple FAQs">
						<FAQForm name="templeFaq" form={form} onChange={handleChange} />
					</Form.Item>
				</Col>
				<Col span={12}>
					<InputComponent
						type={'textarea'}
						name="templeSchema"
						label="Temple FAQs Schema"
						placeholder="Temple FAQs Schema"
						onChange={handleChange}
						rules={templeRequest.faQsSchema}
						rows={9}
					/>
				</Col>
				<Col span={12}>
					<Form.Item label="Property FAQs">
						<FAQForm name="propertyFaq" form={form} onChange={handleChange} />
					</Form.Item>
				</Col>
				<Col span={12}>
					<InputComponent
						type={'textarea'}
						name="propertySchema"
						label="Property FAQs Schema"
						placeholder="Property FAQs Schema"
						onChange={handleChange}
						rules={templeRequest.faQsSchema}
						rows={9}
					/>
				</Col>
			</Row>
		</Form>
	);
});

export default FormComponent;
